import Statistics from './StatisticsNeo.vue';
export default Statistics;
